<template>
    <v-form ref="form" autocomplete="off">
        <v-container fluid>
            <v-row>
                <label class="ml-2">
                    <h3>Ingresar productos a vender:</h3>
                </label>
            </v-row>

            <v-row v-if="showListaPreciosSelector" align="center" class="px-2 mb-1">
                <v-col cols="12" md="4" lg="3" class="py-0">
                    <v-select
                        v-model="listaPreciosVentaId"
                        :items="listasPrecios"
                        item-text="nombre"
                        item-value="id"
                        outlined
                        dense
                        hide-details
                        clearable
                        label="Lista de precios"
                        placeholder="Lista default"
                        prepend-inner-icon="mdi-format-list-numbered"
                        @change="onListaPreciosChange"
                    />
                </v-col>
            </v-row>

            <v-row>
                <movimiento-compra-list
                    cart-table-height="min(20vh, 180px)"
                    :items="itemsCarritoParaTabla"
                    v-model="form"
                    ref="form"
                    @addProductToCart="addProductToCart"
                    @updateCantidad="onUpdateCantidad"
                    @resetForm="resetForm"
                    @delete="deleteItem"
                    @closeDialog="tableDialogClosed"
                    @error="$emit('error', $event)"
                />
            </v-row>
            <v-row align="center" justify="center">
                <!-- SECCIÓN DE PAGO -->
                <v-col cols="8" md="8" lg="6">
                    <v-card class="payment-panel mt-4">
                        <v-card-text>
                            <v-row>
                                <!-- COLUMNA IZQUIERDA -->
                                <v-col cols="12" md="6">
                                    <!-- Descuento -->
                                    <div class="info-card">
                                        <div class="field-label">
                                            <v-icon color="orange" small>mdi-tag-outline</v-icon>
                                            Descuento (%):
                                        </div>
                                        <v-text-field v-model="descuento" type="number" outlined dense
                                            :rules="descuentoRules"></v-text-field>
                                    </div>

                                    <!-- Recargo: lista o valor manual -->
                                    <div class="info-card">
                                        <div class="field-label">
                                            <v-icon color="purple" small>mdi-plus-circle-outline</v-icon>
                                            Recargo (%):
                                        </div>
                                        <v-select
                                            v-model="recargoSeleccionado"
                                            :items="recargoOpciones"
                                            item-text="label"
                                            item-value="value"
                                            outlined
                                            dense
                                            hide-details
                                            clearable
                                            :placeholder="$t('recargo.labels.recargo')"
                                            @change="onRecargoSeleccionadoChange"
                                        ></v-select>
                                        <v-text-field
                                            v-if="recargoSeleccionado === 'manual'"
                                            v-model="recargoManual"
                                            type="number"
                                            outlined
                                            dense
                                            :rules="recargoRules"
                                            :placeholder="$t('recargo.labels.recargo')"
                                            class="mt-2"
                                            @input="emitRecargo"
                                        ></v-text-field>
                                    </div>

                                    <!-- Medios de Pago (múltiples con monto) -->
                                    <div class="info-card">
                                        <div class="field-label">
                                            <v-icon color="blue" small>mdi-credit-card-outline</v-icon>
                                            Medios de pago:
                                        </div>
                                        <div v-for="(item, index) in mediosDePago" :key="index" class="d-flex align-center mb-2">
                                            <v-select
                                                v-model="item.medio"
                                                :items="mediosPago"
                                                outlined
                                                dense
                                                hide-details
                                                class="flex-grow-1 mr-1"
                                                style="min-width: 0;"
                                            ></v-select>
                                            <v-text-field
                                                v-if="mediosDePago.length > 1"
                                                v-model.number="item.monto"
                                                type="number"
                                                prefix="$"
                                                outlined
                                                dense
                                                hide-details
                                                class="flex-grow-1 mr-1"
                                                style="max-width: 120px;"
                                                min="0"
                                                step="0.01"
                                                @input="emitMediosDePago"
                                            ></v-text-field>
                                            <v-btn
                                                v-if="mediosDePago.length > 1"
                                                icon
                                                small
                                                color="error"
                                                @click="quitarMedioDePago(index)"
                                            >
                                                <v-icon small>mdi-minus</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-btn ref="btnAgregarMedio" small text color="primary" @click="agregarMedioDePago" class="mt-1">
                                            <v-icon small left>mdi-plus</v-icon>
                                            Agregar medio de pago
                                        </v-btn>
                                    </div>
                                </v-col>

                                <!-- COLUMNA DERECHA -->
                                <v-col cols="12" md="6">
                                    <!-- Total a Pagar -->
                                    <div class="total-card">
                                        <div class="total-label">Total a Pagar</div>
                                        <div class="total-amount">${{ precioTotal }}</div>
                                    </div>

                                    <!-- Dinero Recibido (por defecto suma de medios; se puede editar) -->
                                    <div class="info-card">
                                        <div class="field-label">
                                            <v-icon color="green" small>mdi-cash</v-icon>
                                            Dinero recibido:
                                        </div>
                                        <v-text-field
                                            v-model.number="dineroRecibido"
                                            type="number"
                                            outlined
                                            dense
                                            hide-details
                                            prefix="$"
                                            min="0"
                                            step="0.01"
                                            @input="emitPagoRecibido"
                                        ></v-text-field>
                                    </div>

                                    <!-- Cambio a Devolver -->
                                    <div class="change-card">
                                        <div class="change-label">
                                            <v-icon>mdi-minus-circle-outline</v-icon>
                                            Cambio a Devolver
                                        </div>
                                        <div class="change-amount" :class="{ 'has-change': cambioADevolver > 0 }">
                                            ${{ cambioADevolver.toFixed(2) }}
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>

import { InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
import { DayjsMixin } from "@dracul/dayjs-frontend";
import MovimientoCompraList from "../MovimientoList/MovimientoCompraList";
import OfertaProvider from "../../../../oferta/providers/OfertaProvider";
import { aplicarOfertasACarritoPreview } from "../../../../oferta/utils/ofertaCalculo";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";
import RecargoProvider from "../../../../recargo/providers/RecargoProvider";
import ListaPreciosVentaProvider from "../../../../lista-precios-venta/providers/ListaPreciosVentaProvider";

export default {
    name: "MovimientoForm",
    mixins: [InputErrorsByProps, RequiredRule, DayjsMixin],
    components: { MovimientoCompraList },
    data() {
        return {
            loading: false,
            fechaDateMenu: false,
            fechaTimeMenu: false,
            showMovimientoAgregarVenta: false,
            formCard: {
                idProducto: null,
            },
            itemsCarrito: [],
            precioTotalCalculado: 0,
            descuentoRules: [
                (v) =>
                    parseFloat(v) >= 0 && parseFloat(v) <= 100 || "El descuento debe ser entre 0% y 100%",
            ],
            recargoRules: [
                (v) =>
                    parseFloat(v) >= 0 && parseFloat(v) <= 100 || "El recargo debe ser entre 0% y 100%",
            ],
            medioDePagoSeleccionados: [],
            // nuevos
            descuento: 0,
            recargo: 0,
            recargoId: null,
            recargoSeleccionado: null,
            recargoManual: 0,
            recargosLista: [],
            mediosDePago: [{ medio: 'Efectivo', monto: 0 }],
            mediosPago: ['Efectivo', 'Tarjeta D\u00e9bito', 'Tarjeta Cr\u00e9dito', 'Transferencia'],
            listasPrecios: [],
            listaPreciosVentaId: null,
            dineroRecibido: 0,
            modalVisible: false,
            ofertasAplicables: [],
            loadingOfertas: false,
            isUpdatingPrices: false, // Bandera para prevenir loops infinitos
            pendingPrecioRecalc: false,
        }
    },
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    computed: {
        form: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        },
        recargoOpciones() {
            const manual = { label: this.$t('recargo.manualOption') || 'Valor manual', value: 'manual' };
            const deLista = (this.recargosLista || []).map((r) => ({
                label: `${r.nombre} (${r.recargo}%)`,
                value: r.id,
            }));
            return [manual, ...deLista];
        },
        precioTotal: function () {
            return (this.precioTotalCalculado * (1 + (this.recargo / 100)) * (1 - (this.descuento / 100))).toFixed(2)
        },
        itemsCarritoParaTabla: function () {
            console.log('🔄 Recalculando itemsCarritoParaTabla...');
            return this.itemsCarrito.map((item) => {
                console.log(`  Item ${item.producto.id}:`, {
                    cantidad: item.cantidad,
                    tieneOferta: !!item.ofertaAplicada,
                    oferta: item.ofertaAplicada
                });
                
                const precioBase = item.producto.precio ?? item.producto.precioVenta;
                let precioFinal = precioBase;
                
                // Si hay oferta aplicada, calcular el precio con descuento
                if (item.ofertaAplicada && item.ofertaAplicada.descuento > 0) {
                    const descuentoPorUnidad = item.ofertaAplicada.descuento / item.cantidad;
                    precioFinal = precioBase - descuentoPorUnidad;
                }
                
                const m = item.producto.marca?.nombre || "";
                const mod = item.producto.modelo?.nombre || "";
                const t = item.producto.tamanio?.tamanio || null;
                const nombre = item.producto.nombre || [m, mod, t].filter(Boolean).join(" · ") || "-";
                const rowId = item.producto.id != null ? item.producto.id : item.producto._id;
                return {
                    id: rowId,
                    stock: item.producto.stock,
                    nombre,
                    precio: precioFinal,
                    precioBase: precioBase,
                    cantidad: item.cantidad,
                    ofertaAplicada: item.ofertaAplicada || null
                }
            })
        },
        totalDescuentoOfertas() {
            let total = 0;
            for (const item of this.itemsCarrito) {
                if (item.ofertaAplicada && item.ofertaAplicada.descuento) {
                    total += item.ofertaAplicada.descuento;
                }
            }
            return total;
        },
        cantidadProductosConOferta() {
            return this.itemsCarrito.filter(item => item.ofertaAplicada).length;
        },
        cambioADevolver() {
            const precioTotalNumero = Number(this.precioTotal);
            const recibido = Number(this.dineroRecibido) || 0;
            const cambio = recibido - precioTotalNumero;
            return cambio > 0 ? cambio : 0;
        },
        /** Medio principal para ofertas (el de mayor monto o primero con monto > 0) */
        medioPagoPrincipal() {
            const conMonto = (this.mediosDePago || []).filter((p) => Number(p.monto) > 0);
            if (conMonto.length === 0) return 'Efectivo';
            const mayor = conMonto.reduce((a, b) => (Number(b.monto) >= Number(a.monto) ? b : a), conMonto[0]);
            return mayor ? mayor.medio : 'Efectivo';
        },
        sumaMediosDePago() {
            if (!this.mediosDePago || !this.mediosDePago.length) return 0;
            return this.mediosDePago.reduce((acc, p) => acc + (Number(p.monto) || 0), 0);
        },
        showListaPreciosSelector() {
            return this.listasPrecios.length > 1;
        }
    },
    watch: {
        itemsCarrito: {
            handler() {
                // Prevenir loop infinito: no ejecutar si ya estamos actualizando precios
                if (!this.isUpdatingPrices) {
                    this.updatePrecioTotal();
                }
            },
            deep: true
        },
        form: {
            handler(newVal) {
                this.$emit('input', newVal)
            },
            deep: true
        },
        descuento: {
            handler(newVal) {
                const value = newVal === '' || newVal == null ? 0 : parseFloat(newVal)
                this.$emit('actualizarDescuento', value)
            }
        },
        recargoManual: {
            handler() {
                if (this.recargoSeleccionado === 'manual') this.emitRecargo();
            }
        },
        mediosDePago: {
            handler() {
                this.emitMediosDePago();
                this.dineroRecibido = this.sumaMediosDePago;
                this.emitPagoRecibido();
                if (this.itemsCarrito.length > 0) {
                    this.updatePrecioTotal();
                }
            },
            deep: true
        }
    },
    created() {
        RecargoProvider.fetchRecargos()
            .then((r) => {
                if (r && r.data && r.data.recargoFetch) this.recargosLista = r.data.recargoFetch;
            })
            .catch(() => { this.recargosLista = []; });
        ListaPreciosVentaProvider.list()
            .then((r) => {
                this.listasPrecios = (r && r.data && r.data.listaPreciosVentaList) || [];
                if (this.listasPrecios.length === 1) {
                    this.listaPreciosVentaId = this.listasPrecios[0].id;
                    this.$emit('actualizarListaPreciosVenta', this.listasPrecios[0].id);
                } else if (!this.listaPreciosVentaId) {
                    const def = this.listasPrecios.find((l) => l.isDefault);
                    const selected = def || this.listasPrecios[0];
                    if (selected) {
                        this.listaPreciosVentaId = selected.id;
                        this.$emit('actualizarListaPreciosVenta', selected.id);
                    }
                }
            })
            .catch(() => { this.listasPrecios = []; });
    },
    methods: {
        onListaPreciosChange(val) {
            this.$emit('actualizarListaPreciosVenta', val || null);
            this.ofertasAplicables = [];
            this.$nextTick(() => this.updatePrecioTotal());
        },
        onRecargoSeleccionadoChange() {
            if (this.recargoSeleccionado === 'manual') {
                this.recargoId = null;
                this.recargo = this.recargoManual === '' || this.recargoManual == null ? 0 : parseFloat(this.recargoManual);
            } else if (this.recargoSeleccionado) {
                const r = this.recargosLista.find((x) => x.id === this.recargoSeleccionado);
                this.recargoId = r ? r.id : null;
                this.recargo = r ? (r.recargo || 0) : 0;
            } else {
                this.recargoId = null;
                this.recargo = 0;
            }
            this.emitRecargo();
        },
        emitRecargo() {
            let recargoNum = 0;
            let recargoIdVal = null;
            if (this.recargoSeleccionado === 'manual') {
                recargoNum = this.recargoManual === '' || this.recargoManual == null ? 0 : parseFloat(this.recargoManual);
            } else if (this.recargoSeleccionado) {
                const r = this.recargosLista.find((x) => x.id === this.recargoSeleccionado);
                recargoNum = r ? (r.recargo || 0) : 0;
                recargoIdVal = r ? r.id : null;
            }
            this.recargo = recargoNum;
            this.recargoId = recargoIdVal;
            this.$emit('actualizarRecargo', { recargo: recargoNum, recargoId: recargoIdVal });
        },
        agregarMedioDePago() {
            this.mediosDePago.push({ medio: 'Efectivo', monto: 0 });
        },
        quitarMedioDePago(index) {
            if (this.mediosDePago.length > 1) {
                this.mediosDePago.splice(index, 1);
                this.emitMediosDePago();
            }
        },
        emitMediosDePago() {
            const list = (this.mediosDePago || []).map((p) => ({
                medio: p.medio || 'Efectivo',
                monto: Number(p.monto) || 0
            }));
            this.$emit('actualizarMediosDePago', list);
        },
        emitPagoRecibido() {
            this.$emit('actualizarPagoRecibido', {
                dineroRecibido: Number(this.dineroRecibido) || 0,
                cambioADevolver: this.cambioADevolver
            });
        },
        validate() {
            return this.$refs.form.validate()
        },
        productoIdStr(producto) {
            if (!producto) return "";
            const v = producto.id != null ? producto.id : producto._id;
            return v != null ? String(v) : "";
        },
        addProductToCart(item) {
            const pid = this.productoIdStr(item.producto);
            const existingItem = this.itemsCarrito.find((itemCarrito) => {
                const sameCodigo =
                    itemCarrito.producto.codigoBarras != null &&
                    item.producto.codigoBarras != null &&
                    itemCarrito.producto.codigoBarras === item.producto.codigoBarras;
                const sameId =
                    pid &&
                    this.productoIdStr(itemCarrito.producto) === pid;
                return sameCodigo || sameId;
            })
            const cantidadNueva = item.cantidad || 1
            const stockDisponible = item.producto.stock
            const cantidadActual = existingItem ? existingItem.cantidad : 0

            // Validar que no se supere el stock disponible
            if (cantidadActual + cantidadNueva > stockDisponible) {
                return
            }

            if (existingItem) {
                // Si el producto ya existe en el carrito, incrementar la cantidad
                existingItem.cantidad += cantidadNueva
                this.$emit('guardarItemCarrito', existingItem)
            } else {
                // Si no existe, mantener el comportamiento actual
                this.itemsCarrito.push(item)
                this.$emit('guardarItemCarrito', item)
            }
            // Actualizar precio total después de agregar producto
            this.updatePrecioTotal();
        },
        onUpdateCantidad({ item, newCantidad }) {
            const targetId =
                item && item.id != null && item.id !== ""
                    ? String(item.id)
                    : this.productoIdStr(item && item.producto);
            const row = this.itemsCarrito.find((it) => {
                if (!it.producto) return false;
                return this.productoIdStr(it.producto) === targetId;
            });
            if (row) {
                const stock = row.producto.stock != null ? row.producto.stock : 0;
                row.cantidad = Math.min(Math.max(1, Number(newCantidad) || 1), stock);
                this.updatePrecioTotal();
            }
        },
        deleteItem(item) {
            const targetId = item && item.id != null ? String(item.id) : "";
            const index = this.itemsCarrito.findIndex(
                (ic) => this.productoIdStr(ic.producto) === targetId
            );
            if (index > -1) {
                // Guardar el item original antes de eliminarlo para pasarlo al evento
                const originalItem = this.itemsCarrito[index];
                this.itemsCarrito.splice(index, 1);
                // Emitir el item original con la estructura { producto: {...}, cantidad: ... }
                this.$emit('eliminarItemCarrito', originalItem);
                // Actualizar precio total después de eliminar producto
                this.updatePrecioTotal();
            }
        },
        resetForm() {
            // this.formCard = { }
        },
        async updatePrecioTotal() {
            if (this.isUpdatingPrices) {
                this.pendingPrecioRecalc = true;
                return;
            }

            this.isUpdatingPrices = true;
            this.pendingPrecioRecalc = false;
            
            try {
                let total = 0;

                if (this.itemsCarrito.length > 0) {
                    await this.calcularOfertasAplicables();

                    const itemsParaCalculo = this.itemsCarrito.map((item) => ({
                        producto: item.producto,
                        cantidad: item.cantidad || 0,
                        precioBase: (item.producto.precio ?? item.producto.precioVenta) || 0,
                    }));
                    const resultados = aplicarOfertasACarritoPreview(
                        itemsParaCalculo,
                        this.ofertasAplicables || []
                    );

                    for (let i = 0; i < this.itemsCarrito.length; i++) {
                        const item = this.itemsCarrito[i];
                        const res = resultados[i] || { precioTotal: 0, ofertaAplicada: null };
                        this.$set(item, "ofertaAplicada", res.ofertaAplicada || null);
                        total += res.precioTotal || 0;
                    }
                }

                this.precioTotalCalculado = total;
            } finally {
                // Diferir el reseteo para evitar loop: el watcher de itemsCarrito (deep) se dispara
                // al hacer $set(item, 'ofertaAplicada', ...). Si reseteamos aquí, cuando el watcher
                // corre ya isUpdatingPrices es false y vuelve a llamar updatePrecioTotal().
                this.$nextTick(() => {
                    this.isUpdatingPrices = false;
                    if (this.pendingPrecioRecalc) {
                        this.pendingPrecioRecalc = false;
                        this.updatePrecioTotal();
                    }
                });
            }
        },
        async calcularOfertasAplicables() {
            if (this.itemsCarrito.length === 0) {
                this.ofertasAplicables = [];
                return;
            }
            
            try {
                this.loadingOfertas = true;
                const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
                
                if (!depositoId) {
                    this.ofertasAplicables = [];
                    return;
                }
                
                // Preparar itemsCarrito para la query
                const itemsCarritoInput = this.itemsCarrito.map(item => ({
                    producto: item.producto.id != null ? item.producto.id : item.producto._id,
                    cantidad: item.cantidad || 0,
                    precioBase: item.producto.precio || item.producto.precioVenta || 0
                }));
                
                const fecha = new Date().toISOString();
                console.log('=== CALCULAR OFERTAS ===');
                console.log('Medio de pago principal:', this.medioPagoPrincipal);
                console.log('Items carrito:', JSON.stringify(this.itemsCarrito));
                console.log('Depósito ID:', depositoId);
                
                const response = await OfertaProvider.getOfertasAplicables(
                    itemsCarritoInput,
                    depositoId,
                    this.medioPagoPrincipal || null,
                    fecha
                );
                
                console.log('Response completo:', JSON.stringify(response));
                console.log('Ofertas recibidas del backend:', response?.data?.ofertasAplicablesMovimiento);
                
                if (response && response.data && response.data.ofertasAplicablesMovimiento) {
                    this.ofertasAplicables = response.data.ofertasAplicablesMovimiento;
                    console.log('Ofertas aplicables asignadas:', JSON.stringify(this.ofertasAplicables));
                } else {
                    this.ofertasAplicables = [];
                    console.log('No hay ofertas aplicables');
                }
            } catch (error) {
                console.error('Error obteniendo ofertas aplicables:', error);
                this.ofertasAplicables = [];
            } finally {
                this.loadingOfertas = false;
            }
        },
        getPrecioTotal() {
            return this.precioTotalCalculado;
        },
        abrirModal() {
            this.modalVisible = true;
        },
        cerrarModal() {
            this.modalVisible = false;
        },
        tableDialogClosed() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const c = this.$refs.btnAgregarMedio;
                    const btn = c && c.$el && c.$el.querySelector && c.$el.querySelector('button');
                    const el = btn || (c && c.$el);
                    if (el && typeof el.focus === 'function') {
                        try {
                            el.focus({ preventScroll: true });
                        } catch (e) {
                            el.focus();
                        }
                    }
                }, 100);
            });
        },
    },
}
</script>

<style scoped>
.pagar-button-container {
    display: flex;
    justify-content: center;
    margin: 24px 0;
}

.pagar-btn {
    min-width: 250px;
    height: 60px !important;
    font-size: 20px !important;
    font-weight: bold;
    letter-spacing: 1px;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
    transition: all 0.3s ease;
}

.pagar-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(76, 175, 80, 0.5);
}

.payment-panel {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 20px;
    border-radius: 12px;
}

.info-card {
    background: white;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.field-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.total-card {
    background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
    padding: 24px;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 16px;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.total-label {
    color: white;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.total-amount {
    color: white;
    font-size: 48px;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.change-card {
    background: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    border: 2px solid #e0e0e0;
}

.change-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    margin-bottom: 8px;
}

.change-amount {
    font-size: 42px;
    font-weight: bold;
    color: #9e9e9e;
}

.change-amount.has-change {
    color: #ff5722;
}

/* ESTILOS DEL MODAL */
.modal-resumen {
    border-radius: 12px;
    overflow: hidden;
}

.modal-header {
    background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
    color: white;
    padding: 20px 24px;
}

.modal-title {
    font-size: 24px;
    font-weight: bold;
}

.modal-content {
    padding: 24px !important;
}

.modal-total-card {
    background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
    padding: 20px;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 20px;
}

.modal-total-label {
    color: white;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
}

.modal-total-amount {
    color: white;
    font-size: 42px;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.modal-info-item {
    background: #f8f9fa;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-info-label {
    font-weight: 600;
    color: #555;
    font-size: 14px;
}

.modal-info-value {
    font-weight: bold;
    color: #333;
    font-size: 16px;
}

.modal-info-value-big {
    font-weight: bold;
    font-size: 24px;
}

.highlight-received {
    background: #e8f5e9;
    border-left: 4px solid #4caf50;
}

.highlight-change {
    background: #fff3e0;
    border-left: 4px solid #ff9800;
}

.highlight-change .change-value {
    color: #ff5722;
}

.modal-actions {
    padding: 16px 24px;
    gap: 12px;
    background: #f5f5f5;
}

.modal-actions .v-btn {
    font-weight: 600;
}

/* Alerta de ofertas */
.ofertas-alert {
    animation: pulseGlow 2s ease-in-out infinite;
    border-left-width: 6px !important;
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);
    }
    50% {
        box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
    }
}
</style>
